module.exports = __webpack_public_path__ + "static/media/sort-numberic-desc.0113a73d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/sort-numberic-desc.svg
// module id = 3521
// module chunks = 7